import { render, staticRenderFns } from "./DueDiligenceDetails.vue?vue&type=template&id=6e7c00ea&"
import script from "./DueDiligenceDetails.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7c00ea')) {
      api.createRecord('6e7c00ea', component.options)
    } else {
      api.reload('6e7c00ea', component.options)
    }
    module.hot.accept("./DueDiligenceDetails.vue?vue&type=template&id=6e7c00ea&", function () {
      api.rerender('6e7c00ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/forms/due-diligence/DueDiligenceDetails.vue"
export default component.exports